<template>
  <div>
    <strong>Sync order</strong>
    <br/><br/>
    <div @keydown.enter="sync_order()">
      <label>Store: </label><StoreSelector v-model="selected_store" />
      <br/><br/>
      <label>Order Shopify ID: </label><input v-validate="'required|numeric'" type="text" v-model="order_shopify_id" name="Order Shopify ID">
      <p class="help is-danger" v-show="errors.has('Order Shopify ID')">
        {{ errors.first('Order Shopify ID') }}
      </p>
      <br/><br/><a id='submit' @click="sync_order()" class="button is-link" :disabled="buttonsDisabled"><span class="icon"><i class="fa fa-refresh"></i></span><span>Sync Order</span></a>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import StoreSelector from './StoreSelector'
import axios from 'axios'

export default {
  name: 'SyncOrder',
  computed: {
    formValidated () {
      return this.selected_store && Object.keys(this.fields).some(key => this.fields[key].validated) && Object.keys(this.fields).some(key => this.fields[key].valid)
    },
    buttonsDisabled () {
      return !this.formValidated || this.force_buttons_disabled
    }
  },
  data () {
    return {
      order_shopify_id: null,
      selected_store: null,
      force_buttons_disabled: false
    }
  },
  methods: {
    sync_order () {
      if (this.force_buttons_disabled) {
        return
      }

      if (this.formValidated) {
        this.force_buttons_disabled = true
        axios.post('/api/sync_order', {
          order_id: this.order_shopify_id,
          shop_url: this.selected_store
        })
          .then(response => {
            this.force_buttons_disabled = false
            this.$root.open_message_modal('Order Sync Scheduled!')
          }).catch(response => {
            this.force_buttons_disabled = false
          })
      } else {
        this.$root.open_error_modal('Incomplete form!')
      }
    }
  },
  created () {
    auth.checkAuth(['read_orders', 'write_orders'])
  },
  components: {
    StoreSelector
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; }
</style>
